<template>
  <div class="">
    <table class="table bg-white table-sm table-striped table-middle fs-sm">
      <thead>
        <tr>
          <th v-if="$root.user.isAdmin" class="th-shrink" />
          <th>Časy vyhodnotenia</th>
          <th class="text-right">Platné od</th>
          <th class="text-right">Platné do</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id">
          <td v-if="$root.user.isAdmin" class="th-shrink">
            <b-dropdown class="btn-p-0" no-caret variant="link">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item @click.prevent="edit(item.id)">
                <b-icon class="mr-1" icon="pencil-square" />
                Upraviť
              </b-dropdown-item>
              <b-dropdown-item
                class="text-danger"
                @click.prevent="remove(item.id)"
              >
                <b-icon class="mr-1" icon="trash" />
                Vymazať
              </b-dropdown-item>
            </b-dropdown>
          </td>
          <td>
            <span v-for="(time, i) in item.time" :key="i" class="mr-3">
              {{ time.from }} - {{ time.to }}
            </span>
          </td>
          <td class="text-right">
            <template v-if="item.from">
              {{ item.from | formatDate }}
            </template>
            <template v-else> - </template>
          </td>
          <td class="text-right">
            <template v-if="item.to">
              {{ item.to | formatDate }}
            </template>
            <template v-else> - </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    energetic: Object,
  },
  methods: {
    edit(id) {
      this.$parent.$parent.$refs.timeForm.id = id
      this.$parent.$parent.add({ edit: true })
    },
    remove(id) {
      this.$parent.$parent.remove(id)
    },
  },
}
</script>
